/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Integrations_TitleInputs */

const en_mk_tb_integrations_title = /** @type {(inputs: Mk_Tb_Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect delivery evidence`)
};

const id_mk_tb_integrations_title = /** @type {(inputs: Mk_Tb_Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungkan bukti pengerjaan`)
};

/**
* | output |
* | --- |
* | "Connect delivery evidence" |
*
* @param {Mk_Tb_Integrations_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_integrations_title = /** @type {((inputs?: Mk_Tb_Integrations_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Integrations_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_integrations_title(inputs)
	return en_mk_tb_integrations_title(inputs)
});